const API_URL = process.env.REACT_APP_API_URL;

export const ENDPOINTS = {
  LOGIN: `${API_URL}${process.env.REACT_APP_LOGIN_ENDPOINT}`,
  REGISTER: `${API_URL}${process.env.REACT_APP_ADD_USER_ENDPOINT}`,
  ACCOUNT: `${API_URL}${process.env.REACT_APP_VIEW_ACCOUNT_ENDPOINT}`,
  ADD_FUND: `${API_URL}${process.env.REACT_APP_FUND_ENDPOINT}`,
  FUND_INVESTMENT: `${API_URL}${process.env.REACT_APP_FUND_INVESTMENT_ENDPOINT}`,
  All_USER_DATA: `${API_URL}${process.env.REACT_APP_All_USER_DATA_ENDPOINT}`,
  ADD_TOKEN_FUND: `${API_URL}${process.env.REACT_APP_ADD_TOKEN_FUND}`,
  UPDATE_USER: `${API_URL}${process.env.REACT_APP_All_UPDATE_USER}`,
  ROLES: `${API_URL}${process.env.REACT_APP_ROLES}`,
  TRANSACTIONS: `${API_URL}${process.env.REACT_APP_TRANSACTION}`,
  COUNTRY: `${API_URL}${process.env.REACT_APP_COUNTRY}`,
  SALE_ORDER: `${API_URL}${process.env.REACT_APP_SALES_ORDER}`,
  PURCHASE_ORDER: `${API_URL}${process.env.REACT_APP_PURCHASE_ORDER}`,
  GET_ORDERS: `${API_URL}${process.env.REACT_APP_GET_ORDERS}`,
  REGION: (countryId) => `${API_URL}/cities/countries/${countryId}/regions/`,
  CITY: (countryId, regionId) =>
    `${API_URL}/cities/countries/${countryId}/regions/${regionId}/cities/`,
  DOCUMENTS: `${API_URL}${process.env.REACT_APP_DOCUMENTS}`,
  FIND_MATCHES: `${API_URL}${process.env.REACT_APP_FIND_MATCHES}`,
  SELECT_MATCHES: `${API_URL}${process.env.REACT_APP_SELECT_MATCHES}`,
  GET_CONTRACTS:`${API_URL}${process.env.REACT_APP_GET_CONTRACTS}`,
  APPROVE_OR_DENY_CONTRACT:`${API_URL}${process.env.REACT_APP_APPROVE_OR_DENY_CONTRACT}`
};
